"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var _require = require("../generated/utils"),
  wrapperForImpl = _require.wrapperForImpl;

// If we were to implement the MutationObserver by spec, the MutationObservers will not be collected by the GC because
// all the MO are kept in a mutation observer list (https://github.com/jsdom/jsdom/pull/2398/files#r238123889). The
// mutation observer list is primarily used to invoke the mutation observer callback in the same order than the
// mutation observer creation.
// In order to get around this issue, we will assign an increasing id for each mutation observer, this way we would be
// able to invoke the callback in the creation order without having to keep a list of all the mutation observers.
var mutationObserverId = 0;

// https://dom.spec.whatwg.org/#mutationobserver
var MutationObserverImpl = /*#__PURE__*/function () {
  // https://dom.spec.whatwg.org/#dom-mutationobserver-mutationobserver
  function MutationObserverImpl(globalObject, args) {
    _classCallCheck(this, MutationObserverImpl);
    var _args = _slicedToArray(args, 1),
      callback = _args[0];
    this._callback = callback;
    this._nodeList = [];
    this._recordQueue = [];
    this._id = ++mutationObserverId;
  }

  // https://dom.spec.whatwg.org/#dom-mutationobserver-observe
  _createClass(MutationObserverImpl, [{
    key: "observe",
    value: function observe(target, options) {
      var _this = this;
      if (("attributeOldValue" in options || "attributeFilter" in options) && !("attributes" in options)) {
        options.attributes = true;
      }
      if ("characterDataOldValue" in options & !("characterData" in options)) {
        options.characterData = true;
      }
      if (!options.childList && !options.attributes && !options.characterData) {
        throw new TypeError("The options object must set at least one of 'attributes', 'characterData', or 'childList' " + "to true.");
      } else if (options.attributeOldValue && !options.attributes) {
        throw new TypeError("The options object may only set 'attributeOldValue' to true when 'attributes' is true or " + "not present.");
      } else if ("attributeFilter" in options && !options.attributes) {
        throw new TypeError("The options object may only set 'attributeFilter' when 'attributes' is true or not " + "present.");
      } else if (options.characterDataOldValue && !options.characterData) {
        throw new TypeError("The options object may only set 'characterDataOldValue' to true when 'characterData' is " + "true or not present.");
      }
      var existingRegisteredObserver = target._registeredObserverList.find(function (registeredObserver) {
        return registeredObserver.observer === _this;
      });
      if (existingRegisteredObserver) {
        var _iterator = _createForOfIteratorHelper(this._nodeList),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var node = _step.value;
            node._registeredObserverList = node._registeredObserverList.filter(function (registeredObserver) {
              return registeredObserver.source !== existingRegisteredObserver;
            });
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        existingRegisteredObserver.options = options;
      } else {
        target._registeredObserverList.push({
          observer: this,
          options: options
        });
        this._nodeList.push(target);
      }
    }

    // https://dom.spec.whatwg.org/#dom-mutationobserver-disconnect
  }, {
    key: "disconnect",
    value: function disconnect() {
      var _this2 = this;
      var _iterator2 = _createForOfIteratorHelper(this._nodeList),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var node = _step2.value;
          node._registeredObserverList = node._registeredObserverList.filter(function (registeredObserver) {
            return registeredObserver.observer !== _this2;
          });
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
      this._recordQueue = [];
    }

    // https://dom.spec.whatwg.org/#dom-mutationobserver-takerecords
  }, {
    key: "takeRecords",
    value: function takeRecords() {
      // TODO: revisit if https://github.com/jsdom/webidl2js/pull/108 gets fixed.
      var records = this._recordQueue.map(wrapperForImpl);
      this._recordQueue = [];
      return records;
    }
  }]);
  return MutationObserverImpl;
}();
module.exports = {
  implementation: MutationObserverImpl
};